var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportPublications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3665 27.9503C36.6724 28.2675 36.8402 28.693 36.8331 29.1336C36.8269 29.5733 36.6472 29.9926 36.3332 30.3003L32.9998 33.5336C32.6821 33.8283 32.2664 33.9945 31.8331 34.0003C31.6101 33.9961 31.3898 33.9509 31.1832 33.867C30.8819 33.7394 30.6249 33.526 30.4441 33.2533C30.2633 32.9806 30.1667 32.6608 30.1665 32.3336V30.667H25.1665C24.7245 30.667 24.3005 30.4914 23.988 30.1788C23.6754 29.8663 23.4998 29.4423 23.4998 29.0003C23.4998 28.5583 23.6754 28.1344 23.988 27.8218C24.3005 27.5092 24.7245 27.3336 25.1665 27.3336H30.1665V25.667C30.1645 25.3339 30.2623 25.0078 30.4474 24.7308C30.6325 24.4539 30.8963 24.2387 31.2049 24.1132C31.5134 23.9876 31.8525 23.9574 32.1784 24.0264C32.5043 24.0954 32.802 24.2605 33.0331 24.5003L36.3665 27.9503Z",
    fill: "url(#paint0_linear_11686_2531)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8332 10.667V19.0003C36.8332 19.4424 36.6576 19.8663 36.345 20.1788C36.0325 20.4914 35.6085 20.667 35.1665 20.667H30.1665C27.5143 20.667 24.9708 21.7206 23.0954 23.5959C21.2201 25.4713 20.1665 28.0148 20.1665 30.667C20.1665 31.109 19.9909 31.5329 19.6783 31.8455C19.3658 32.1581 18.9419 32.3337 18.4998 32.3337H5.0665C3.76694 32.3337 2.52061 31.8174 1.60168 30.8985C0.682752 29.9796 0.166504 28.7332 0.166504 27.4337V5.66699C0.166504 4.34091 0.693288 3.06914 1.63097 2.13146C2.56865 1.19378 3.84042 0.666992 5.1665 0.666992H13.3832C14.1994 0.668483 15.0028 0.869761 15.7233 1.25325C16.4438 1.63674 17.0594 2.19078 17.5165 2.86699L18.8998 4.93366C19.0543 5.1622 19.263 5.34883 19.5074 5.47682C19.7517 5.60481 20.024 5.67015 20.2998 5.66699H31.8332C33.1593 5.66699 34.431 6.19378 35.3687 7.13146C36.3064 8.06914 36.8332 9.34091 36.8332 10.667Z",
    fill: "url(#paint1_linear_11686_2531)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11686_2531",
    x1: 25.175,
    y1: 24.1865,
    x2: 34.6352,
    y2: 34.0107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11686_2531",
    x1: 4.77306,
    y1: 1.28779,
    x2: 34.5654,
    y2: 28.1822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportPublications);
export default __webpack_public_path__ + "static/media/export-publications.542c145de005e751393e1219f755935c.svg";
export { ForwardRef as ReactComponent };